<template>
  <div class="bg-black text-white antialiased font-body">
    <div class="lg:min-h-screen flex flex-col lg:flex-row">
        <Tracks />
    </div>
  </div>
  <div class="fixed right-0 bottom-0 text-white p-2 underline text-gray-500 bg-black text-sm"><a href="https://www.buymeacoffee.com/ianleckey" target="_blank" rel="noopener">If you like this, buy me a coffee?</a> <a href="https://twitter.com/ianleckey">Or just follow me on twitter.</a></div>
</template>

<script>
import Tracks from "./components/Tracks.vue";
export default {
  name: "App",
  data() {
    return {
    };
  },
  components: {
    Tracks,
  },
};
</script>